import React from 'react';
import Helmet from "react-helmet";
import Swiper from 'swiper/core';
import { Link } from 'react-router-dom';
import { withRouter, RouteComponentProps } from 'react-router';
// model && interfaces
import Data from '../../model/Data';
import CityInterface from '../../model/City';
import VacancyInterface from '../../model/Vacancy';
// common components
import Grid from '../../common/components/Grid/Grid';
import VacancyPlate from '../../common/components/VacancyPlate/VacancyPlate';
import SwiperCarousel from '../../common/components/Swiper/SwiperCarousel';
// Local components
import Header from './components/Header/Header';
import Description from './components/Description/Description';
import DesktopFormBlock from './components/DesktopFormBlock/DesktopFormBlock';
import MobileFormBlock from './components/MobileFormBlock/MobileFormBlock';
// styles
import './Vacancy.css';
import './Vacancy320.css';
import './Vacancy768.css';
import './Vacancy1024.css';
import './Vacancy1280.css';
import './Vacancy1376.css';
import './Vacancy1920.css';
// helpers
import ResizeHelper from '../../common/helpers/resize';
import useYandexRotor from "../../common/helpers/useYandexRotor";


interface MatchParams {
  id: string;
  city: string;
  vacancy: string;
}

type Props = RouteComponentProps<MatchParams>;


class Vacancy extends React.Component<Props, {id: string}> {

  private vacancy: VacancyInterface | undefined;

  private vacancies: Array<VacancyInterface> = [];

  private city: CityInterface;

  constructor(props: Props) {
    super(props);
    const uriParams: MatchParams = this.props.match.params;
    this.city = Data.Instance.cities[0];

    try {
      this.vacancy = Data.Instance.getVacancyByAlias(uriParams.vacancy);
      this.city = Data.Instance.cityByAlias(uriParams.city);

      const hasCity = this.vacancy.cities.some((c) => c.id === this.city.id);

      if (!hasCity) throw new Error(`${this.vacancy.name} doesn't belong to ${this.city.name}`)

      const { id, area } = this.vacancy;
      this.vacancies = Data.Instance.vacancies({area: area, city: this.city.id})
      this.state = { id }
      this.switchVacancy = this.switchVacancy.bind(this);
      ResizeHelper.Instance.addCallback(this.refresh.bind(this));
    } catch (error) {
      window.location.href = '/';
    }
  }

  refresh(): void {
    this.setState((prevState) => ({...prevState}))
  }

  private switchVacancy(ev: React.MouseEvent<HTMLAnchorElement>) {
    ev.preventDefault();
    ev.stopPropagation();
    const id: string | null = ev.currentTarget.getAttribute('data-id');

    if (id) {
      const vacancy = Data.Instance.getVacancy(id);
      this.props.history.replace(vacancy.uri_alias);
      this.setState({ id: vacancy.id });
    }
  }

  private vacancyPlates() {
    const plates = this.vacancies.map((v) => {
      return (
        <VacancyPlate
          className={ v.id === this.state.id ? 'selected' : undefined}
          key={v.id}
          city={this.city}
          vacancy={v}
          onClick={this.switchVacancy}
        />
      );
    });

    if (this.vacancy) {
      const area = Data.Instance.area(this.vacancy.area);
      plates.push(
        <Link
          key={`/${this.city.uri_alias}/${area.uri_alias}/special-vacancy`}
          to={`/${this.city.uri_alias}/${area.uri_alias}/special-vacancy`}
          className={`vacancy vacancy-plate special-vacancy-plate item`}
        >
          <div className="name">Нет вакансии для тебя?</div>
          <div className="description">
            Расскажи, кем ты себя видишь в Учи.ру
          </div>
        </Link>
      );
    }
    return plates;
  }

  private onSwiper(swiper: Swiper) {
    const slideTo = (i: number) => {
      swiper.slideTo(i);
    }

    swiper.slides.forEach((slide, i) => {
      slide.addEventListener("click", () => { slideTo(i)} );
    })
  }


  private leftbarText(isDesktop = true) {
    if (isDesktop) {
      return (
        <>
          <span>Узнаёшь</span><br/>
          <span>в описании себя?</span><br/>
          <span>Дай нам знать!</span>
        </>
      );
    } else {
      return (
        <>
          <span>Узнаёшь в описании себя?</span><br/>
          <span>Дай нам знать!</span>
        </>
      );
    }
  }

  private formBlock(vacancy: VacancyInterface) {
    if (Grid.isMobile()) {
      return (
        <MobileFormBlock
          className="hidden mobile-visible tablet-visible"
          vacancy={vacancy}
          key={`mobile-form-block-${vacancy.id}`}
          text={this.leftbarText(false)}
        />
      )
    } else {
      return (
        <DesktopFormBlock
          className="mobile-hidden tablet-hidden"
          vacancy={vacancy}
          key={`desktop-form-block-${vacancy.id}`}
          text={this.leftbarText()}
        />
      )
    }
  }

  render(): JSX.Element {
    const vacancy = Data.Instance.getVacancy(this.state.id);
    const initialSlideId = this.vacancies.findIndex((v) => this.vacancy && (v.id === vacancy.id))

    useYandexRotor(Data.Instance.isDataLoaded);

    return (
      <div className="vacancy-detailed">
        <Helmet
          title={vacancy.name}
          key={`helmet-${vacancy.id}`}
        />
        <Header area={Data.Instance.area(vacancy.area)} city={this.city}></Header>
        <div className="vacancies">
          <SwiperCarousel
            onSwiper={ this.onSwiper.bind(this) }
            initialSlide={ initialSlideId > -1 ? initialSlideId : 0}
          >
            { this.vacancyPlates() }
          </SwiperCarousel>
        </div>
        <Description vacancy={vacancy} key={`descr-${vacancy.id}`} city={this.city}></Description>
        { this.formBlock(vacancy) }
      </div>
    );
  }
}

export default withRouter(Vacancy);
